import {
  Building2,
  CarFront,
  CarTaxiFront,
  FileText,
  HeartPulse,
  ShieldCheck,
  WalletCards,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Badge, Button, Card } from "../components/ui";
import { useTenantRuntime } from "../config/TenantRuntime";

export function PortalPage() {
  const { tenant, hasModule } = useTenantRuntime();
  const assetVertical = hasModule("assets");

  return (
    <div className="public-page">
      <div className="portal-page">
        <header className="portal-header">
          <div>
            <p className="eyebrow">PORTAL DO CLIENTE</p>
            <h1>{tenant.branding.shortName}</h1>
            <p>
              {assetVertical
                ? "Acompanhe contratos, ativos, parcelas e pagamentos em um só lugar."
                : "Acompanhe seus contratos, benefícios e cobranças em um só lugar."}
            </p>
          </div>
          <Button variant="secondary">Sair</Button>
        </header>

        <section className="portal-grid">
          {hasModule("funeral_assistance") && (
            <Card>
              <ShieldCheck size={24} />
              <h2>Plano funerário</h2>
              <Badge tone="success">ATIVO</Badge>
              <p>Consulte cobertura, carência, dependentes e forma de acionamento.</p>
              <Button variant="secondary">Ver cobertura</Button>
            </Card>
          )}

          {hasModule("telemedicine") && (
            <Card>
              <HeartPulse size={24} />
              <h2>Telemedicina</h2>
              <Badge tone="success">ATIVA</Badge>
              <p>Acesso seguro à plataforma MobiMedical.</p>
              <Button>Acessar telemedicina</Button>
            </Card>
          )}

          {hasModule("vehicle_sales") && (
            <Card>
              <CarFront size={24} />
              <h2>Veículo comprado</h2>
              <Badge tone="success">CONTRATO ATIVO</Badge>
              <p>Consulte saldo, parcelas, documentos e situação da transferência.</p>
              <Button variant="secondary">Ver contrato</Button>
            </Card>
          )}

          {hasModule("property_leases") && (
            <Card>
              <Building2 size={24} />
              <h2>Imóvel alugado</h2>
              <Badge tone="success">LOCAÇÃO ATIVA</Badge>
              <p>Contrato, vencimentos, reajustes e comprovantes.</p>
              <Button variant="secondary">Ver locação</Button>
            </Card>
          )}

          {hasModule("vehicle_rentals") && (
            <Card>
              <CarTaxiFront size={24} />
              <h2>Veículo alugado</h2>
              <Badge tone="success">LOCAÇÃO ATIVA</Badge>
              <p>Pagamentos, quilometragem, inspeções e responsabilidades.</p>
              <Button variant="secondary">Ver veículo</Button>
            </Card>
          )}

          {hasModule("billing") && (
            <Card>
              <WalletCards size={24} />
              <h2>Financeiro</h2>
              <p>Pix, boleto, vencimentos e histórico de pagamentos.</p>
              {hasModule("public_payment_portal") ? (
                <Link to="/segunda-via">
                  <Button>Emitir segunda via</Button>
                </Link>
              ) : (
                <Button>Ver cobranças</Button>
              )}
            </Card>
          )}

          <Card>
            <FileText size={24} />
            <h2>Documentos</h2>
            <p>Contratos, termos, evidências e comprovantes.</p>
            <Button variant="secondary">Abrir documentos</Button>
          </Card>
        </section>
      </div>
    </div>
  );
}
